import { Outlet, createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { DroidMapMetadata } from '@droidmap/shared-service-contract'

export const Route = createFileRoute(
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless',
)({
  params: {
    parse: (params) => ({
      projectId: z.string().parse(params.projectId),
    }),
  },
  beforeLoad: async ({ params, context }) => {
    const { orgId, projectId } = params
    const metadata: DroidMapMetadata = {
      ...context.metadata,
      orgId,
      projectId,
    }
    return { metadata }
  },
  loader: async ({ params, context }) => {
    const { orgId, projectId } = params
    const { projectClient } = context.client
    const project = await projectClient.getProject(
      { projectId },
      context.metadata,
    )
    return { crumb: project.name, orgId, projectId, project }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
